import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=bda36e78&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=bda36e78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda36e78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bda36e78')) {
      api.createRecord('bda36e78', component.options)
    } else {
      api.reload('bda36e78', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=bda36e78&scoped=true&", function () {
      api.rerender('bda36e78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25dOhK1Wq4b7o/JS/comp/PopupBox.vue"
export default component.exports